import { render, staticRenderFns } from "./TabClosedOverlay.vue?vue&type=template&id=1513a3d4&scoped=true"
import script from "./TabClosedOverlay.vue?vue&type=script&lang=js"
export * from "./TabClosedOverlay.vue?vue&type=script&lang=js"
import style0 from "./TabClosedOverlay.vue?vue&type=style&index=0&id=1513a3d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1513a3d4",
  null
  
)

export default component.exports